<template>
  <UiInputCheckboxGroupVeeBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TValidationRules } from '@team-milva/lab-components'

interface ICheckboxOption {
  value: string
  text: string
  description?: string
  itemClass?: string
  textClass?: string
  checkboxClass?: string
  isDisabled?: boolean
  hideCheckWhenDisabled?: boolean
}

export default {
  name: 'UiInputCheckboxGroupVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    modelValue: { type: Array as PropType<string[]>, required: true as const },
    options: {
      type: Array as PropType<ICheckboxOption[]>,
      required: true as const,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: undefined,
    },
    rules: { type: Array as PropType<TValidationRules[]>, default: undefined },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
  },
}
</script>

<style>
@reference "../../globals/css/base.css";

.s-checkbox-card-group {
  @apply items-start gap-2;

  &.s-checkbox-card-group--horizontal {
    @apply items-center gap-4;
  }

  .checkbox-card {
    @apply rounded-md p-2 hover:bg-surface-muted;
  }

  .checkbox-card:not(.checkbox-card--disabled):hover .checkbox-card__checkbox {
    @apply border-action;
  }

  .checkbox-card__text {
    @apply pt-px font-medium;
  }

  .checkbox-card__description {
    @apply text-sm font-normal text-text-secondary;
  }

  .checkbox-card__checkbox {
    @apply rounded border border-border-subtle bg-surface text-text-primary;

    .checkbox-card__checkbox__icon {
      @apply hidden;
    }
  }

  .checkbox-card--disabled {
    @apply pointer-events-none opacity-60;
  }

  .checkbox-card--checked {
    .checkbox-card__checkbox {
      @apply border-action bg-action text-text-on-action;

      .checkbox-card__checkbox__icon {
        @apply block;
      }
    }
  }

  .checkbox-card--overridden {
    @apply bg-surface-muted;

    &:hover {
      @apply bg-surface-sunken;
    }

    .checkbox-card__text {
      @apply text-action;
    }

    .checkbox-card__checkbox {
      @apply border-action text-action;
    }

    &.checkbox-card--checked {
      .checkbox-card__checkbox {
        @apply border-action bg-action text-text-on-action;
      }
    }
  }

  &[data-invalid='true'] .checkbox-card__checkbox {
    @apply border-error;
  }
}
</style>

